import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{contactContent.title}</h2>
        </div>

        <div className="max-w-[720px] mx-auto bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10 text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-5">
            <i className="ri-mail-send-fill text-2xl text-accent-500"></i>
          </div>
          <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-3">你有猛料？我们来曝光</h3>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-[480px] mx-auto mb-6">
            {contactContent.desc}
          </p>

          <div className="inline-flex items-center gap-3 px-5 py-3 bg-background-100 rounded-md border border-background-200/60">
            <i className="ri-mail-line text-lg text-foreground-500"></i>
            <span className="text-sm font-medium text-foreground-700">{contactContent.email}</span>
            <button
              onClick={() => { navigator.clipboard.writeText(contactContent.email); }}
              className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              复制邮箱
            </button>
          </div>

          <p className="mt-4 text-xs text-foreground-400">所有投稿严格保密 · 绝不泄露线人身份 · 审核通过后24小时内发布</p>
        </div>
      </div>
    </section>
  );
}